"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var _a;
var guestia_storage_1 = require("./guestia_storage");
var SEARCHES_URL = '/user/searches/';
var STORAGE_KEY = 'searches';
var MAX_LS_SEARCHES = 5;
var storage = new guestia_storage_1["default"]('localStorage', (_a = {},
    _a[STORAGE_KEY] = { defaultValue: [], storageProvider: 'localStorage' },
    _a));
var Search = /** @class */ (function () {
    function Search(apiClient, searchUUID, searchParams, cheapestTicket) {
        // XXX: change validation
        if (!(searchParams && cheapestTicket)) {
            throw new Error('searchParams and cheapestTicket are required');
        }
        this.searchUUID = searchUUID;
        this.apiClient = apiClient;
        this.searchParams = searchParams;
        this.cheapestTicket = cheapestTicket;
    }
    Search.save = function (apiClient, searchUUID, searchParams, cheapestTicket) {
        return new Promise(function (resolve, reject) {
            var search = new Search(apiClient, searchUUID, searchParams, cheapestTicket);
            search
                .save()
                .then(resolve)["catch"](reject);
        });
    };
    Search.getStorageSearches = function () {
        try {
            return JSON.parse(storage.get(STORAGE_KEY)) || [];
        }
        catch (error) {
            return [];
        }
    };
    Search.savePreviousSearches = function (apiClient) {
        return new Promise(function (resolve, reject) {
            var lsSearches = Search.getStorageSearches();
            if (lsSearches && lsSearches.length) {
                Promise.all(lsSearches.map(function (_a) {
                    var id = _a.id, ticket = _a.ticket, search_params = _a.search_params;
                    var search = new Search(apiClient, id, search_params, ticket);
                    return search.save();
                }))
                    .then(function (res) {
                    storage.remove(STORAGE_KEY);
                    resolve(res);
                })["catch"](reject);
            }
            else {
                resolve('No previous searches');
            }
        });
    };
    Search.fetchSearches = function (apiClient) {
        return new Promise(function (resolve, reject) {
            if (!apiClient.getJWT()) {
                resolve({ searches: Search.getStorageSearches() });
            }
            else {
                apiClient
                    .get(SEARCHES_URL, {})
                    .then(resolve)["catch"](reject);
            }
        });
    };
    Search.prototype.save = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var params = {
                search: {
                    id: _this.searchUUID,
                    ticket: _this.cheapestTicket,
                    search_params: _this.searchParams
                }
            };
            if (!_this.apiClient.getJWT()) {
                try {
                    var searches = Search.getStorageSearches();
                    if (searches.length - MAX_LS_SEARCHES >= 0) {
                        var from = searches.length - MAX_LS_SEARCHES + 1;
                        searches = searches.slice(from, from + MAX_LS_SEARCHES);
                    }
                    var search = __assign({}, params.search, { created_at: new Date().toISOString() });
                    searches.push(search);
                    storage.set(STORAGE_KEY, JSON.stringify(searches));
                    resolve(search);
                }
                catch (error) {
                    reject(error);
                }
            }
            else {
                return _this.apiClient.post(SEARCHES_URL, params);
            }
        });
    };
    return Search;
}());
exports["default"] = Search;
